import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ProgramNode } from '../../../common/models/care-monitor/program-node';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { ProgramAnswer } from '../../../common/models/care-monitor/program-answer';
import { Program, ProgramLog } from '@meplis/common';

@Component({
  selector: 'mec-program-checkbox',
  imports: [CommonModule, MatCheckboxModule, FormsModule, ReactiveFormsModule],
  templateUrl: './program-checkbox.component.html',
  styleUrls: ['./program-checkbox.component.scss'],
})
export class ProgramCheckboxComponent implements OnDestroy {
  @Input() public programNode: ProgramNode;
  @Output() public onSelectItemChange = new EventEmitter<ProgramLog>();

  public formGroup: FormGroup;
  public subscription: Subscription;
  public isAllAboveChecked: boolean = false;
  public isNoneAboveChecked: boolean = false;

  constructor(private _formBuilder: FormBuilder) {}

  public ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (this.programNode) {
      this.formGroup = this._formBuilder.group({
        options: this._formBuilder.array(
          Object.keys(this.programNode?.values).map((key) => {
            true;
          })
        ),
      });

      const control = this.formGroup.controls['options'];
      this.subscription = control.valueChanges.subscribe((result) => {
        const valuesSelected = Object.keys(this.programNode.values)
          .map((node, index) => {
            if (result[index]) {
              return this.programNode.values[index].value;
            }
          })
          .filter((node) => node != null);

        if (valuesSelected.length > 0) {
          this.isNoneAboveChecked = false;
        }

        const programAnswer: ProgramAnswer = {
          name: this.programNode.variable.name,
          value: valuesSelected,
        };

        const isValid = this._validateMinMaxValues(valuesSelected.length);
        this._selectItems(programAnswer, isValid);
      });
    }
  }

  private _selectItems(programAnswer: ProgramAnswer, isValid: boolean): void {
    const log = {
      to: this.programNode.id,
      at: new Date().toISOString(),
      results: [programAnswer],
    };

    this.onSelectItemChange.emit({ ...log, valid: isValid });
  }

  private _validateMinMaxValues(checkedCount: number): boolean {
    const minValue = this.programNode?.validation?.minValue;
    const maxValue = this.programNode?.validation?.maxValue;

    if (minValue && checkedCount < minValue) {
      return false;
    }

    if (maxValue && checkedCount > maxValue) {
      return false;
    }

    return true;
  }

  public selectAllAbove(event: any): void {
    const optionsArray = this.formGroup.get('options') as any;
    if (optionsArray) {
      if (event.checked) {
        Object.keys(this.programNode?.values).forEach((key, index) => {
          optionsArray.at(index).setValue(true);
        });
        this.isNoneAboveChecked = false;
        this.isAllAboveChecked = true;
      } else {
        Object.keys(this.programNode?.values).forEach((key, index) => {
          optionsArray.at(index).setValue(false);
        });
        this.isAllAboveChecked = false;
      }
    }
  }

  public selectNoneAbove(event: any): void {
    const optionsArray = this.formGroup.get('options') as any;
    if (optionsArray) {
      if (event.checked) {
        Object.keys(this.programNode?.values).forEach((key, index) => {
          optionsArray.at(index).setValue(false);
        });
        this.isAllAboveChecked = false;
        this.isNoneAboveChecked = true;
      } else {
        this.isNoneAboveChecked = false;
      }
    }
  }

  public isCheckboxDisabled(index: number): boolean {
    const minValue = this.programNode?.validation?.minValue;
    const maxValue = this.programNode?.validation?.maxValue;
    const optionsArray = this.formGroup.get('options') as any;

    if (!optionsArray || (!minValue && !maxValue)) {
      return false;
    }

    const checkedCount = Object.keys(this.programNode?.values).filter(
      (key, i) => optionsArray.at(i).value === true
    ).length;

    if (maxValue && checkedCount >= maxValue) {
      return !optionsArray.at(index).value;
    }

    return false;
  }
}
